import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#07a3e0',
    },
    secondary: {
      main: '#2e495c',
    },
  },
});

export default theme;
